import React from 'react'
import PropTypes from 'prop-types'
import { Document, Page } from 'react-pdf/build/entry.webpack'

import Styles from '../index.scss'

const FullTextPreview = props => (
  <div className={props.rootClassName}>
    <Document
      file={props.portfolio.url}
      onLoadSuccess={({ numPages }) => props.setNumPages(numPages)}
      className={props.documentClassName}
    >
      {
        [...Array(props.numPages)].map((item, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            scale={props.scale}
            className={props.pageClassName}
            renderTextLayer={props.renderTextLayer}
          />
        ))
      }
    </Document>
  </div>
)

FullTextPreview.defaultProps = {
  portfolio: {
    url: '',
  },
  setNumPages: () => {},
  numPages: 1,
  scale: 1,
  rootClassName: `text-center ${Styles['full-pdf']}`,
  documentClassName: '',
  pageClassName: '',
  renderTextLayer: false,
}

FullTextPreview.propTypes = {
  portfolio: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  setNumPages: PropTypes.func,
  numPages: PropTypes.number,
  rootClassName: PropTypes.string,
  documentClassName: PropTypes.string,
  renderTextLayer: PropTypes.bool,
}

export default FullTextPreview
